import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Filters = ({
  setTypeFilter,
  todoActiveCount,
  todos,
  setTodos,
  todoDoneCount,
  typeFilter,
}) => (
  <>
    <span className="todo-count">
      {`${todoActiveCount().length} items left`}
    </span>
    <ul className="filters">
      <li>
        <a
          href="#/"
          className={classNames({ selected: typeFilter === 'All' })}
          onClick={event => setTypeFilter(event.target.innerText)}
        >
          All
        </a>
      </li>

      <li>
        <a
          href="#/active"
          className={classNames({ selected: typeFilter === 'Active' })}
          onClick={event => setTypeFilter(event.target.innerText)}
        >
          Active
        </a>
      </li>

      <li>
        <a
          href="#/completed"
          className={classNames({ selected: typeFilter === 'Completed' })}
          onClick={event => setTypeFilter(event.target.innerText)}
        >
          Completed
        </a>
      </li>
    </ul>

    {(todoDoneCount().length > 0) && (
      <button
        type="button"
        className="clear-completed"
        onClick={() => setTodos(todos.filter(item => !item.completed))}
      >
        Clear completed
      </button>
    )}
  </>
);

Filters.propTypes = {
  setTypeFilter: PropTypes.func.isRequired,
  todoActiveCount: PropTypes.func.isRequired,
  setTodos: PropTypes.func.isRequired,
  todoDoneCount: PropTypes.func.isRequired,
  typeFilter: PropTypes.bool.isRequired,
  todos: PropTypes.arrayOf().isRequired,
};
